<template>
	<div>
		<v-container>
			<v-breadcrumbs :items="breadcrumbs">
				<template #divider>
					<v-icon>mdi-chevron-left</v-icon>
				</template>
			</v-breadcrumbs>

			<app-dashboard-icons :privileges="privileges" :sections="sections"></app-dashboard-icons>
		</v-container>
	</div>
</template>

<script>
import client from "@/client";

export default {
	components: {
		AppDashboardIcons: () => import(/* webpackChunkName: "app-dashboard-icons" */ "@/components/app/dashboard/AppDashboardIcons")
	},
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			privs: {},
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'الإعلانات', disabled: true }
			],
			sections: [
				{
					title: "الإعلانات",
					items: [
						{
							title: "إضافة",
							icon: "mdi-plus-box",
							route: "/dashboard/ads/add",
							priv: "new"
						},
						{
							title: "تحكم",
							icon: "mdi-view-dashboard",
							route: "/dashboard/ads/manage",
							priv: "manage"
						},
					]
				}
			],
		};
	},
	computed: {
		privileges() {
			const privs = this.privs;
			if (privs == undefined || Object.keys(privs).length == 0) {
				return {};
			}
			return privs;
		}
	},
	mounted() {
		this.getNewsPrivileges();
	},
	methods: {
		getNewsPrivileges() {
			client
				.get("/api/privilege/unspokenIcons ")
				.then(response => {
					console.log(response);
					this.privs = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		}
	}
};
</script>